import { talentHeroArc, talentHeroArcShadowBg } from "assets/website";

const TalentHero = () => {
  return (
    <section className="relative overflow-hidden bg-white pt-[140px] md:pt-[200px] sm:px-4 md:px-6">
      <div className="relative container mx-auto flex flex-col items-center text-center">
        {/* Headline */}
        <h1
          data-aos="fade-up"
          className="max-w-[900px] text-[28px] md:text-5xl lg:text-[64px] font-display font-[600] text-[#00003F] leading-tight tracking-[-0.5px] mb-5 md:mb-6"
        >
          Improve Performance Outcomes with Better Systems
        </h1>

        {/* Subheadline */}
        <p
          data-aos="fade-up"
          data-aos-delay="100"
          className="max-w-[720px] text-base md:text-xl text-[#475467] mb-16 px-2 md:px-0"
        >
          The Talent Enablement provides the frameworks, tools, and expertise
          organisations need to execute goals, improve accountability, manage,
          and build high-performing teams.
        </p>

        {/* Arc with avatars */}
        <div className="relative w-full max-w-[920px] -mb-[6%]">
          {/* Blue glow ring background */}
          <img
            src={talentHeroArcShadowBg}
            aria-hidden="true"
            className="pointer-events-none absolute left-1/2 sm:-bottom-14 [max-w-400]:-bottom-4 -bottom-2 -translate-x-1/2 sm:w-[130%] [max-w-400]:w-[120%] w-[120%] max-w-none select-none"
            draggable={false}
          />
          <img
            src={talentHeroArc}
            alt="Engineers, digital marketers, and product managers"
            className="relative w-full h-auto select-none"
            draggable={false}
          />
        </div>
      </div>
    </section>
  );
};

export { TalentHero };
